import { ref } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import {
  getStudiesClinician,
  registerStudyClinician,
  updateStudyClinician,
  updateInactiveOrActiveStudyClinician,
} from '@/studies/services/studies';

export function useStudiesClinician() {
  const studies = ref([]);
  const isLoading = ref(false);

  const fetchStudies = async () => {
    isLoading.value = true;
    try {
      studies.value = await getStudiesClinician();
    } catch (error) {
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  };

  const createStudy = async (payload) => {
    isLoading.value = true;
    try {
      const id = uuidv4();
      await registerStudyClinician(payload, id);
      await fetchStudies();
    } finally {
      isLoading.value = false;
    }
  };

  const editStudy = async (data) => {
    isLoading.value = true;
    try {
      await updateStudyClinician(data);
      await fetchStudies();
    } finally {
      isLoading.value = false;
    }
  };

  const removeStudy = async (id) => {
    isLoading.value = true;
    try {
      await updateInactiveOrActiveStudyClinician(id, false);
      await fetchStudies();
    } finally {
      isLoading.value = false;
    }
  };

  const toggleActive = async (study) => {
    isLoading.value = true;
    try {
      await updateInactiveOrActiveStudyClinician(study.id, study.isActive);
      await fetchStudies();
    } finally {
      isLoading.value = false;
    }
  };

  return {
    studies,
    isLoading,
    fetchStudies,
    createStudy,
    editStudy,
    removeStudy,
    toggleActive,
  };
}
